// extracted by mini-css-extract-plugin
module.exports = {"searchResult":"Autocomplete_searchResult__FjIQo"};